import { useMemo } from "react"

import { useSessionsQuery } from "@/features/chat/hooks/use-sessions-query"
import { filterSessionFileRefs } from "@/features/chat/utils/session-file-refs"

/**
 * Efficiently extracts file_refs for a specific session from the cached sessions query.
 * Uses the same cache as the sidebar - no extra API call.
 */
export function useSessionFileRefs(
  sessionId: string | undefined,
  sessionType: string,
  projectId?: string
) {
  const { data: sessions = [], ...rest } = useSessionsQuery(sessionType, projectId)

  // Memoize the file refs extraction to avoid recomputation on every render
  const fileRefs = useMemo(() => {
    if (!sessionId || sessions.length === 0) return []
    const session = sessions.find((s) => s?.id === sessionId)
    const refs = session?.file_refs ?? []
    return filterSessionFileRefs(refs)
  }, [sessionId, sessions])

  return { data: fileRefs, ...rest }
}
